/**
 * Define all the action types for the common components
 */

export const GET_DEV_DATA = 'MODULE_NAME:GET_DEV_DATA';
export const GET_DEV_DATA_SUCCESS = 'MODULE_NAME:GET_DEV_DATA_SUCCESS';
export const GET_DEV_DATA_FAILURE = 'MODULE_NAME:GET_DEV_DATA_FAILURE';

export const SET_USER_DETAILS = 'LOGIN:SET_USER_DETAILS';
export const SET_IS_AUTHENTICATED_WITH_HYBRIS =
    'LOGIN:SET_IS_AUTHENTICATED_WITH_HYBRIS';

export const GET_AUTH_TOKEN = 'AUTH:GET_AUTH_TOKEN';
export const GET_AUTH_TOKEN_SUCCESS = 'AUTH:GET_AUTH_TOKEN_SUCCESS';
export const GET_AUTH_TOKEN_FAILURE = 'AUTH:GET_AUTH_TOKEN_FAILURE';

export const GET_HYBRIS_USER_DETAILS_LOADING = 'AUTH:GET_HYBRIS_USER_DETAILS_LOADING';
export const GET_HYBRIS_USER_DETAILS = 'AUTH:GET_HYBRIS_USER_DETAILS';
export const GET_HYBRIS_USER_DETAILS_SUCCESS =
    'AUTH:GET_HYBRIS_USER_DETAILS_SUCCESS';
export const GET_HYBRIS_USER_DETAILS_FAILURE =
    'AUTH:GET_HYBRIS_USER_DETAILS_FAILURE';

export const LOGIN = 'AUTH:LOGIN';
export const LOGIN_SUCCESS = 'AUTH:LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'AUTH:LOGIN_FAILURE';

export const GET_CONFIGURATION = 'GET_CONFIGURATION';
export const GET_CONFIGURATION_SUCCESS = 'GET_CONFIGURATION_SUCCESS';
export const GET_CONFIGURATION_FAILURE = 'GET_CONFIGURATION_FAILURE';

export const SET_LOGOUT = 'AUTH:SET_LOGOUT';
export const SET_LOGOUT_SUCCESS = 'AUTH:SET_LOGOUT_SUCCESS';
export const SET_LOGOUT_FAILURE = 'AUTH:SET_LOGOUT_FAILURE';

export const SET_LOGOUT_SSO = 'AUTH:SET_LOGOUT_SSO';

export const GET_BANNER_DETAILS = 'GET_BANNER_DETAILS';
export const GET_BANNER_DETAILS_SUCCESS = 'GET_BANNER_DETAILS_SUCCESS';
export const GET_BANNER_DETAILS_FAILURE = 'GET_BANNER_DETAILS_FAILURE';
export const GET_BANNER_LENGTH = 'GET_BANNER_LENGTH';
export const SET_BANNER_FREQUECY = 'SET_BANNER_FREQUECY';

export const SHOW_DISMISSED_BANNER = 'SHOW_DISMISSED_BANNER';
export const HIDE_DISMISSED_BANNER = 'HIDE_DISMISSED_BANNER';

export const SET_BANNER_HEIGHT = 'SET_BANNER_HEIGHT';
export const SET_FORBIDDEN_ERROR_CHECK_VALUE =
    'SET_FORBIDDEN_ERROR_CHECK_VALUE';
export const SET_CONFIG_TABLE_RULES = 'SET_CONFIG_TABLE_RULES';
export const SET_MAST_ORDER = 'SET_MAST_ORDER';
export const SET_BANNER_DETAILS = 'SET_BANNER_DETAILS';
export const SET_CONFIRMATION_BANNER = 'SET_CONFIRMATION_BANNER';
export const SET_DESTRUCTIVE = 'SET_DESTRUCTIVE';
export const SET_PEDIATRIC_CHECK = 'COMMON:SET_PEDIATRIC_CHECK';



//HeaderNotes
export const HANDLE_EQUITY_NOTES='HANDLE_EQUITY_NOTES';
export const HANDLE_CONSIGNMENT_BILLING_NOTES='HANDLE_CONSIGNMENT_BILLING_NOTES';
export const HANDLE_CONSIGNMENT_ADD_NOTES='HANDLE_CONSIGNMENT_ADD_NOTES';
export const HANDLE_REPORT_USAGE_NOTES='HANDLE_REPORT_USAGE_NOTES';
export const HANDLE_SURGERY_NOTES='HANDLE_SURGERY_NOTES';
export const RESET_NOTES = 'RESET_NOTES';
export const IS_CONDENSED_VIEW = 'IS_CONDENSED_VIEW';
export const IS_HEADER_CONDENSED_VIEW = 'IS_HEADER_CONDENSED_VIEW';
export const IS_HIDE_CONDENSED_VIEW = 'IS_HIDE_CONDENSED_VIEW';

// QR code

export const GET_QR_CODE_REQUEST = 'GET_QR_CODE_REQUEST';
export const GET_QR_CODE_SUCCESS = 'GET_QR_CODE_SUCCESS';
export const GET_QR_CODE_FAILURE = 'GET_QR_CODE_FAILURE';
export const CLEAR_QR_CODE = 'CLEAR_QR_CODE';
export const SET_QR_GENERATED = 'SET_QR_GENERATED';

// Batch Export
export const GET_BATCH_EXPORT_REQUEST = 'GET_BATCH_EXPORT_REQUEST';
export const GET_BATCH_EXPORT_SUCCESS = 'GET_BATCH_EXPORT_SUCCESS';
export const GET_BATCH_EXPORT_FAILURE = 'GET_BATCH_EXPORT_FAILURE';
export const CLEAR_BATCH_EXPORT = 'CLEAR_BATCH_EXPORT';

//Banner
export const RESET_BANNERS='RESET_BANNERS';
